
let API_ROOT = 'http://localhost:3100/'
// 牛牛
// const API_ROOT = 'http://120.77.144.239:3100/'
const PIC_ROOT = 'http://120.78.91.121:3008/'

// 商会
// const API_ROOT = 'http://120.77.144.239:3101/'
// const PIC_ROOT = 'http://120.77.144.239:3008/'

// bak
// const API_ROOT = 'http://120.77.144.239:3702/'
// const PIC_ROOT = 'http://120.77.144.239:3008/'

!(process.env.NODE_ENV === 'development') && (API_ROOT = 'http://120.78.91.121:3100/')

const API_VER = 'v1'
export default {
  editorPrintLog: false,
  serverAddr: API_ROOT + API_VER,
  sockerAddr: API_ROOT,
  picAddr: PIC_ROOT,
  baiduAK: 'ULwd78BkkuEAEz2HfGUtQ9uuA5qG8mlh'
}




// WEBPACK FOOTER //
// ./src/assets/js/config.js